import React, { useState, useEffect } from "react";
import "./Withoutabha.css";
import { useLanguage } from "../../../utils/languageContext";
import axios from "axios"; // Import axios
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { toast } from "react-toastify";

import { ncdAPI } from "../../../services/ncd.api";
import { sickleAPI } from "../../../services/sickle.api";
import { nikshayAPI } from "../../../services/nikshay.api";
import { checkUserLoginForProgram } from "../../../utils/authUtils";
import { uwinAPI } from "../../../services/uwin.api";
import { getActivePrograms } from "../../../services/activePrograms.service";

export const Withoutabha = () => {
	const { t } = useLanguage();
	const [activePrograms, setActivePrograms] = useState(null);
	const [profiles, setProfiles] = useState(null);
	const [sklprofiles, setSklProfiles] = useState(null);
	const [nikshayProfiles, setNikshayProfiles] = useState(null);
	const [uwinProfiles, setUwinProfiles] = useState(null);
	const [isPageLoading, setIsPageLoading] = useState(false);
	const navigate = useNavigate(); // React Router hook for navigation

	const [errors, setErrors] = useState({});

	const [err, setErr] = useState("");

	const [selectedPrograms, setSelectedPrograms] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	const [formData, setFormData] = useState({
		name: "",
		dob: "",
		gender: "",
		phoneNumber: "",
	});

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});

		// Clear error for the current field if user types something
		setErrors((prevErrors) => {
			const newErrors = { ...prevErrors };
			if (e.target.value.trim() !== "") {
				delete newErrors[e.target.name];
			}
			return newErrors;
		});

	};

	useEffect(() => {
		// Check if token exists in local storage
		const token = localStorage.getItem("NCD_token") || localStorage.getItem("sickle_token") || localStorage.getItem("PMNDP_token") || localStorage.getItem("NIKSHAY_valid_user") || localStorage.getItem("uwin_token") || localStorage.getItem("JANANI_token") || localStorage.getItem("RBSK_token");
		if (!token) {
			navigate("/");
		}
	}, [navigate]); // run on mount

	useEffect(() => {
		fetchPrograms();
		//localStorage.removeItem("NIKSHAY_Registration_Detials");
		//localStorage.removeItem("NCD_Searchdetails");
	}, []);

	const fetchPrograms = async () => {
		const progresp = await getActivePrograms();
		const filteredPrograms = (progresp.data || []).filter(
			(program) => program.search_included === 1
		);
		setActivePrograms(filteredPrograms);
	};

	const validate = () => {
		const newErrors = {};

		// Name → required, fixed length (example: 3–50 chars), no special characters
		if (!formData.name?.trim()) {
			newErrors.name = "Name is required";
		}
		// Only letters and spaces allowed + fixed length (change length if needed)
		else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
			newErrors.name = "Name should not contain special characters or numbers";
		}
		else if (formData.name.length < 3 || formData.name.length > 30) {
			newErrors.name = "Name must be between 3 and 30 characters";
		}

		// DOB → optional but must be valid if provided
		if (formData.dob && formData.dob.trim() !== "") {
			const selectedDate = new Date(formData.dob);
			const today = new Date();

			if (isNaN(selectedDate.getTime())) {
				newErrors.dob = "Invalid date";
			} else if (selectedDate > today) {
				newErrors.dob = "DOB cannot be in the future";
			} else {
				// Optional: Age limit (0–120 years)
				const minDate = new Date();
				minDate.setFullYear(minDate.getFullYear() - 120);

				if (selectedDate < minDate) {
					newErrors.dob = "Age limit should be (0-120 years)";
				}
			}
		}

		// Gender → required
		if (!formData.gender) {
			newErrors.gender = "Gender is required";
		}

		// Mobile → optional, but if provided must be 10 digits only
		if (formData.phoneNumber && formData.phoneNumber.trim()) {
			if (!/^\d+$/.test(formData.phoneNumber)) {
				newErrors.phoneNumber = "Mobile number should contain only numbers";
			}
			else if (formData.phoneNumber.length < 10) {
				newErrors.phoneNumber = "Mobile number cannot be less than 10 digits";
			}
			else if (formData.phoneNumber.length > 10) {
				newErrors.phoneNumber = "Mobile number cannot be more than 10 digits";
			}
		}

		return newErrors;
	};

	const handleCheckboxChange = (e, programId) => {
		if (e.target.checked) {
			setSelectedPrograms((prev) => [...prev, programId]);
		} else {
			setSelectedPrograms((prev) => prev.filter((id) => id !== programId));
		}
	};

	// Calculate age from DOB
	const calculateAge = (dob) => {
		if (!dob) return null;
		const birthDate = new Date(dob);
		const today = new Date();

		let age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();

		// Adjust age if birthday hasn't come yet this year
		if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	};

	const setData = async (data, type) => {
		if (data) {
			setIsPageLoading(true);

			if (type === "NCD") {
				const individualId = data.individualId;

				try {
					const resp = await ncdAPI.getLeftPanel(individualId);

					if (!resp?.data?.patientDetails) {
						console.error("Patient details not found in response");
						setIsPageLoading(false);
						return;
					}

					let dob = resp.data.patientDetails.dateOfBirth || "";
					let yearOfBirth = "";

					if (dob && dob.includes("-")) {
						let [day, month, year] = dob.split("-");
						let formattedDate = `${year}-${month}-${day}`;
						yearOfBirth = new Date(formattedDate).getFullYear();
					}

					//alert(data.subcenterId);

					const beneficiaryData = {
						name: (resp.data.patientDetails.name || "") + (resp.data.patientDetails.surname ? " " + resp.data.patientDetails.surname : ""),
						abhaNo: data.healthId || null,
						originalabha: resp.data.patientDetails.healthId || null,
						searchedindividualId: individualId || null,
						subcenterId: data.subcenterId || null,
						address: "",
						mobile: formData.phoneNumber || resp.data.patientDetails.mobileNumber || "",
						dob: resp.data.patientDetails.dateOfBirth || "",
						yearOfBirth: yearOfBirth ? "XX-XX-" + yearOfBirth : "",
						gender: resp.data.patientDetails.gender || "",
						base64photo: resp.data.patientDetails.photo || null,
						kycphoto:
							data.gender === "M"
								? "/images/male.svg"
								: data.gender === "F"
									? "/images/female.svg"
									: "/images/male.svg",
					};

					localStorage.setItem(
						"beneficiaryDetails",
						JSON.stringify(beneficiaryData)
					);
					localStorage.setItem(
						"orignalBeneficiaryData",
						JSON.stringify(beneficiaryData)
					);

					localStorage.setItem(
						"NCD_Searchdetails",
						JSON.stringify(beneficiaryData)
					);

				} catch (error) {
					console.error("Error fetching NCD patient details:", error);
					setIsPageLoading(false);
					return;
				}
			}

			if (type === "Sickle") {
				let dob = data.dob_aadhar;
				let yearOfBirth = null;
				let formattedDate = null;

				if (dob && dob.includes("-")) {
					const [day, month, year] = dob.split("-");
					formattedDate = `${year}-${month}-${day}`;
					const parsedYear = new Date(formattedDate).getFullYear();
					yearOfBirth =
						isNaN(parsedYear) || parsedYear === 0 ? null : parsedYear;
				}

				const beneficiaryData = {
					name: data.NameOfPerson,
					abhaNo: data.abha_id,
					originalabha: data.abha_id,
					address: data.Address,
					mobile: data.InchargeMobile,
					dob: data.dob_aadhar,
					gender: data.Gender === "M" ? "Male" : data.Gender === "F" ? "Female" : "Other",
					base64photo: null,
					kycphoto:
						data.gender === "M"
							? "/images/male.svg"
							: data.gender === "F"
								? "/images/female.svg"
								: "/images/male.svg",
					BloodGroupID: data.BloodGroupID,
					category: data.category,
					MaritalStatus: data.MaritalStatus,
					SonDaughterOfWifeOf: data.SonDaughterOfWifeOf,
				};

				if (yearOfBirth) {
					beneficiaryData.yearOfBirth = "XX-XX-" + yearOfBirth;
				}

				localStorage.setItem(
					"beneficiaryDetails",
					JSON.stringify(beneficiaryData)
				);
				localStorage.setItem(
					"orignalBeneficiaryData",
					JSON.stringify(beneficiaryData)
				);
			}

			if (type === "Nikshay") {
				const beneficiaryData = {
					name: `${data.FirstName} ${data.LastName}`,
					abhaNo: null,
					originalabha: null,
					address: "",
					mobile: data.PrimaryPhoneNumber,
					dob: "",
					yearOfBirth: "",
					gender: data.Gender,
					base64photo: null,
					kycphoto: data.Gender === "Female" ? "/images/female.svg" : "/images/male.svg",
				};

				localStorage.setItem(
					"beneficiaryDetails",
					JSON.stringify(beneficiaryData)
				);
				localStorage.setItem(
					"orignalBeneficiaryData",
					JSON.stringify(beneficiaryData)
				);

				localStorage.removeItem("NIKSHAY_Registration_Detials");

				localStorage.setItem(
					"NIKSHAY_Registration_Detials",
					JSON.stringify(data)
				);
			}

			if (type === "Uwin") {

				let dob = data.dob || "";
				let yearOfBirth = "";

				if (dob && dob.includes("-")) {
					let [day, month, year] = dob.split("-");
					let formattedDate = `${year}-${month}-${day}`;
					yearOfBirth = new Date(formattedDate).getFullYear();
				}

				const beneficiaryData = {
					name: `${data.ben_name}`,
					abhaNo: null,
					originalabha: null,
					address: "",
					mobile: data.ben_mobile_number,
					dob: data.dob,
					yearOfBirth: yearOfBirth ? "XX-XX-" + yearOfBirth : "",
					gender: data.beneficiary_gender,
					base64photo: null,
					kycphoto: data.beneficiary_gender === "Female" ? "/images/female.svg" : "/images/male.svg",
				};

				localStorage.setItem(
					"beneficiaryDetails",
					JSON.stringify(beneficiaryData)
				);
				localStorage.setItem(
					"orignalBeneficiaryData",
					JSON.stringify(beneficiaryData)
				);
			}

			setIsPageLoading(false);

			navigate("/detailsabha");
		}
	};

	const createNewProfile = () => {
		let dateofbirth = formData.dob?.trim();

		let day = "",
			month = "",
			year = "",
			formattedDOB = "",
			yearOfBirth = "";

		if (dateofbirth && dateofbirth.includes("-")) {
			const parts = dateofbirth.split("-");
			if (parts.length === 3) {
				if (parts[0].length === 4) {
					// YYYY-MM-DD format (HTML date input)
					[year, month, day] = parts;
				} else {
					// DD-MM-YYYY format
					[day, month, year] = parts;
				}

				if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
					formattedDOB = `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
					yearOfBirth = year;
				}
			}
		}

		const beneficiaryData = {
			name: formData.name || "",
			abhaNo: null,
			originalabha: null,
			searchedindividualId: null,
			address: "",
			mobile: formData.phoneNumber || "",
			dob: formattedDOB,
			yearOfBirth: yearOfBirth ? `XX-XX-${yearOfBirth}` : "",
			gender:
				formData.gender === "M"
					? "Male"
					: formData.gender === "F"
						? "Female"
						: "Other",
			base64photo: null,
			kycphoto: formData.gender === "F" ? "/images/female.svg" : "/images/male.svg",
			profilePhoto: null,
			preferredAbhaAddress: null,
			email: null,
			abhaNumber: null,
			districtlgd: null,
			statelgd: null,
			mobileOriginal: formData.phoneNumber
		};

		localStorage.removeItem("NIKSHAY_Registration_Detials");

		localStorage.setItem("NIKSHAY_NEW_PROFILE", true);

		localStorage.setItem("beneficiaryDetails", JSON.stringify(beneficiaryData));
		localStorage.setItem(
			"orignalBeneficiaryData",
			JSON.stringify(beneficiaryData)
		);

		navigate("/detailsabha");
	};

	const searchNCDWithoutValidation = async () => {
		try {
			const stored = localStorage.getItem("NCD_loggedinUserdetails");
			const subcenter = stored ? JSON.parse(stored) : null;

			let payload = {
				limit: 40,
				page: 0,
				name: formData.name || "",
				idValue: "", // 91-5626-5803-0217 - Pass for search via abha number.
				status: "",
				phoneNumber: formData.phoneNumber || "",
				districtScope: true,
			};

			if (subcenter.rolename != 'MO' && subcenter.rolename != 'STAFF_NURSE' && subcenter.rolename != 'DEO') {
				payload.subcenterId = subcenter?.facility || "";
				payload.villageId = null;
			}

			const records = await ncdAPI.searchBeneficiary(payload);

			const results = Array.isArray(records) ? records : [];
			setProfiles(results);
			return results;
		} catch (error) {
			console.error("Error in searchNCD:", error);
			setProfiles([]);
			return [];
		}
	};

	const searchSickleWithoutValidation = async () => {

		try {

			if (!formData.phoneNumber?.trim()) {
				setSklProfiles([]);
				return [];
			}

			const response = await sickleAPI.searchBeneficiary(
				formData.phoneNumber
			);

			// ================= HANDLE RESPONSE =================

			const patientList =
				response?.data?.Patientsickleid || [];

			if (patientList.length === 0) {

				console.warn("No sickle beneficiary found.");

				setSklProfiles([]);

				return [];
			}

			// ================= GET ALL REGISTRATION DETAILS =================

			const allRegistrations = [];

			for (const patient of patientList) {

				// const payload = {
				// 	sickle_id: patient?.sickle_id,
				// 	health_facility_id:
				// 		localStorage.getItem("health_facility_id") || "",
				// 	disease_type: 1,
				// };

				// try {

				// 	const resp =
				// 		await sickleAPI.getRegistrationDetails(payload);

				// 	const registrations =
				// 		resp?.PatientDetails
				// 			?.map((p) => p.registration)
				// 			?.filter(Boolean) || [];

				// 	allRegistrations.push(...registrations);

				// } catch (innerError) {

				// 	console.error(
				// 		`Error fetching details for sickle_id ${patient?.sickle_id}`,
				// 		innerError
				// 	);
				// }
				// allRegistrations.push(patient);
			}

			setSklProfiles(allRegistrations);

			return allRegistrations;

		} catch (error) {

			console.error("Error in searchSickle:", error);

			setSklProfiles([]);

			return [];
		}
	};

	const searchNikshayWithoutValidation = async () => {
		try {
			if (!formData.phoneNumber?.trim()) {
				setNikshayProfiles([]);
				return [];
			}

			let gender = '';
			const g = formData.gender?.toUpperCase();

			if (g === 'M') {
				gender = 'Male';
			} else if (g === 'F') {
				gender = 'Female';
			} else if (g === 'O') {
				gender = 'Other';
			}

			const response = await nikshayAPI.checkDuplicates({
				PrimaryPhone: formData.phoneNumber,
				Gender: gender
			});

			if (Array.isArray(response?.data?.Data) && response?.data?.Data?.length > 0) {
				setNikshayProfiles(response?.data?.Data);
				return response?.data?.Data;
			} else {
				setNikshayProfiles([]);
				return [];
			}
		} catch (error) {
			 toast.error(error.response.data.message, {
                    className: "custom-toast-error",
                });
			return false;
		}
	};

	const encryptText = async (plaintext) => {
		try {
			const accessToken = localStorage.getItem('Backend_token');
			const resEncrypt = await axios.post("nodeapi/uwin/encryption", {
				plaintext: plaintext
			}, {
				headers: {
					"Content-Type": "application/json",
					"Authorization": `Bearer ${accessToken}`,
				}
			});
			return resEncrypt.data.data.encrypted;
		} catch (error) {
			console.error("Backend login error:", error);
		}
	};

	const getClientToken = async () => {
		const user = JSON.parse(localStorage.getItem("uwin_loggedinUserdetails"));
		const res = await axios.post("nodeapi/uwin/client-token", {
			user_id: user?.user_id,
		});
		if (res.data.success) {
			localStorage.setItem("uwin_token", res.data.data.accessToken);
		}
	};

	const searchUwinWithoutABHA = async () => {
		try {

			const payload = {
				search_value: await encryptText(formData.phoneNumber),
				search_by: "mobile-number"
			};
			await getClientToken();
			const dtResponse = await uwinAPI.searchBeneficiary(payload);
			if (dtResponse.success) {
				const results = Array.isArray(dtResponse.data) ? dtResponse.data : [];
				setUwinProfiles(results);
				return results;
			} else {
				setUwinProfiles([]);
				return [];
			}
		} catch (error) {
			console.error("Error in searchUwin:", error);
			setUwinProfiles([]);
			return [];
		}
	};

	const searchBeneficiary = async (e) => {
		e.preventDefault();
		setCurrentPage(1);
		// Set loading true at the start
		setIsPageLoading(true);

		try {
			const validationErrors = validate();

			if (
				Object.keys(validationErrors).length > 0 ||
				selectedPrograms.length === 0
			) {
				setErrors(validationErrors);
				if (selectedPrograms.length === 0) {
					setErr("Please select at least one program.");
				} else {
					setErr("");
				}
				setIsPageLoading(false); // Stop loading on validation error
				return;
			}

			setErrors({});
			setErr("");

			const tasks = [];

			if (selectedPrograms.includes(1)) {
				tasks.push(searchNCDWithoutValidation());
			}

			if (selectedPrograms.includes(2)) {
				tasks.push(searchSickleWithoutValidation());
			}

			if (selectedPrograms.includes(4)) {
				tasks.push(searchNikshayWithoutValidation());
			}

			if (selectedPrograms.includes(6)) {
				tasks.push(searchUwinWithoutABHA());
			}

			// if (selectedPrograms.includes(8)) {
			//     tasks.push(searchPMNDPWithoutValidation());
			// }

			const results = await Promise.all(tasks);
			const [ncdResults = [], sickleResults = [], nikshayResults = [], uwinResults = []] = results;

			// Only create new profile if no results found AND user wants to proceed
			if (ncdResults.length === 0 && sickleResults.length === 0 && nikshayResults.length === 0 && uwinResults.length === 0) {
				createNewProfile();
			}
			// If results are found, they will be displayed in the table below
		} catch (error) {
			console.error("Error in getting beneficiary list:", error);
		} finally {
			setIsPageLoading(false); // Ensure loading is stopped even if error occurs
		}
	};

	const combinedResults = [
		...(profiles || []).map((p) => ({ ...p, program: "NCD" })),
		...(sklprofiles || []).map((p) => ({ ...p, program: "Sickle" })),
		...(nikshayProfiles || []).map((p) => ({ ...p, program: "Nikshay" })),
		...(uwinProfiles || []).map((p) => ({ ...p, program: "Uwin" })),
	];


	const indexOfLast = currentPage * itemsPerPage;
	const indexOfFirst = indexOfLast - itemsPerPage;
	const currentResults = combinedResults.slice(indexOfFirst, indexOfLast);
	const totalPages = Math.ceil(combinedResults.length / itemsPerPage);

	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	return (
		<div className="">
			{isPageLoading && <Loader />}
			<div className="page-detailsABHA">
				<div className="container-fluid">
					<form onSubmit={searchBeneficiary}>
						<div className="withou-abha-bg">
							<h3>{t('withoutabha.title')}</h3>

							<div className="form-container">
								<h5 className="pd-title">{t('withoutabha.personalDetails')}</h5>

								<div className="form-row d-flex flex-wrap">
									<div className="input-wrapper">
										<TextField
											fullWidth
											label={t('withoutabha.name')}
											name="name"
											value={formData.name}
											onChange={handleChange}
											error={!!errors.name}
											helperText={errors.name}
											variant="standard"
											size="small"
											sx={{
												'& .MuiInputBase-root': { height: 40 },
												'& .MuiInputBase-input': { padding: '8px 0 4px' },
											}}
										/>
									</div>

									<div className="input-wrapper input-wrapperDatePicker">
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DatePicker
												label={t('withoutabha.dob')}
												value={formData.dob ? dayjs(formData.dob) : null}
												onChange={(newValue) => {
													setFormData({
														...formData,
														dob: newValue ? newValue.format('YYYY-MM-DD') : '',
													});
													// Clear error for dob if user selects a date
													setErrors((prevErrors) => {
														const newErrors = { ...prevErrors };
														delete newErrors.dob;
														return newErrors;
													});
												}}
												maxDate={dayjs()}
												slotProps={{
													textField: {
														fullWidth: true,
														size: 'small',
														variant: 'standard',
														error: !!errors.dob,
														helperText: errors.dob,
														sx: {
															'& .MuiInputAdornment-root .MuiIconButton-root': {
																padding: '0 2px',
																marginBottom: '2px',
																'& svg': { fontSize: '1rem' },
															},
														},
													},
												}}
											/>
										</LocalizationProvider>
									</div>

									<div className="input-wrapper">
										<FormControl
											fullWidth
											size="small"
											error={!!errors.gender}
											variant="standard"
											sx={{
												'& .MuiInputBase-root': {
													height: 40,
													alignItems: 'flex-end',
												},
												'& .MuiSelect-select': { paddingBottom: '4px' },
											}}
										>
											<InputLabel>{t('withoutabha.gender')}</InputLabel>
											<Select
												name="gender"
												value={formData.gender}
												onChange={handleChange}
												label={t('withoutabha.gender')}
											>
												<MenuItem value="">{t('withoutabha.selectGender')}</MenuItem>
												<MenuItem value="M">{t('withoutabha.male')}</MenuItem>
												<MenuItem value="F">{t('withoutabha.female')}</MenuItem>
												<MenuItem value="O">{t('withoutabha.transgender')}</MenuItem>
											</Select>
											{errors.gender && (
												<FormHelperText>{errors.gender}</FormHelperText>
											)}
										</FormControl>
									</div>

									<div className="input-wrapper">
										<TextField
											fullWidth
											label={t('withoutabha.phone')}
											name="phoneNumber"
											value={formData.phoneNumber}
											onChange={handleChange}
											error={!!errors.phoneNumber}
											helperText={errors.phoneNumber}
											variant="standard"
											size="small"
											sx={{
												'& .MuiInputBase-root': { height: 40 },
												'& .MuiInputBase-input': { padding: '8px 0 4px' },
											}}
										/>
									</div>
								</div>
							</div>

							<h3 className="choose-program">{t('withoutabha.chooseProgram')}</h3>
							<div className="programs row">
								{activePrograms?.length > 0 &&
									activePrograms.map((prog, index) => {
										return (
											<React.Fragment key={prog.program_id || index}>
												{/* {checkUserLoginForProgram(prog.program_id) && */}
												{checkUserLoginForProgram(prog.program_id) && prog?.program_id !== 5 &&
													(<div className="col-lg-2 col-md-3 col-sm-4 col-6" key={index}>
														<div className="program">
															<label>
																<input
																	type="checkbox"
																	name="program-checkbox"
																	id="ncdCheckbox"
																	value={prog.program_id}
																	onChange={(e) =>
																		handleCheckboxChange(e, prog.program_id)
																	}
																/>
																<img
																	src={
																		prog.program_id === 1
																			? "/images/programs_logo/ncd.svg"
																			: prog.program_id === 2
																				? "/images/programs_logo/sickle.svg"
																				: prog.program_id === 4
																					? "/images/programs_logo/nikshay.svg"
																					: prog.program_id === 5
																						? "/images/programs_logo/janani.png"
																						: prog.program_id === 6
																							? "/images/programs_logo/uwin.svg"
																							: prog.program_id === 8
																								? "/images/programs_logo/pmndp.svg"
																								: prog.program_id === 11
																									? "/images/programs_logo/rbsk.svg"
																									: ""
																	}
																	alt="program-icon"
																	className="program-icon"
																/>
																<span>{prog.program_name}</span>
															</label>
														</div>
													</div>)}
											</React.Fragment>
										);
									})}

								{err && <span className="werror">{err}</span>}
							</div>

							<div className="button-container-abha">
								<button type="submit" className="search-btn-abha">
									{t('withoutabha.submit')}
								</button>
							</div>
						</div>
					</form>

					{(profiles?.length > 0 || sklprofiles?.length > 0 || nikshayProfiles?.length > 0 || uwinProfiles?.length > 0) && (
						<>
							<div className="program-selection-sectionn">
								<h3>{t('withoutabha.suggestedMatches')}</h3>
								<p>
									{(profiles?.length || 0) + (sklprofiles?.length || 0) + (nikshayProfiles?.length || 0) + (uwinProfiles?.length || 0)} {t('withoutabha.resultsFound')}
								</p>

								<p>
									<b>{t('withoutabha.note')}</b>{t('withoutabha.noteText')}
								</p>

								<div className="table-container">
									<table className="table-th-box">
										<thead>
											<tr>
												<th>Program</th>
												<th>Profile</th>
												<th>Name</th>
												<th>Age</th>
												<th>Gender</th>
												<th>Phone</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody>

										</tbody>{currentResults.map((person, index) => {

											let name = "";
											let age = "";
											let gender = "";
											let phone = "";
											let photo = "/images/Profile.png";

											if (person.program === "NCD") {
												name = person.name;
												age = person.age > 0 ? `${person.age} Years` : "";
												gender =
													person.gender === "M"
														? "Male"
														: person.gender === "F"
															? "Female"
															: "Other";
												phone = person.indvPhoneNo;
												photo = person.photo
													? `data:image/jpeg;base64,${person.photo}`
													: "/images/Profile.png";
											}

											if (person.program === "Sickle") {
												name = person.NameOfPerson;
												gender =
													person.Gender === "M"
														? "Male"
														: person.Gender === "F"
															? "Female"
															: "Other";
												phone = person.InchargeMobile;
											}

											if (person.program === "Nikshay") {
												name = `${person.FirstName} ${person.LastName}`;
												age = person.Age;
												gender = person.Gender;
												phone = person.PrimaryPhoneNumber;
											}

											if (person.program === "Uwin") {
												name = person.ben_name;
												age = calculateAge(person.dob);
												gender = person.beneficiary_gender;
												phone = person.ben_mobile_number;
											}

											return (
												<tr key={index}>

													<td>

														{person.program === "NCD" && (
															<Tooltip title="NCD">
																<img src="/images/programs_logo/ncd.svg" />
															</Tooltip>
														)}

														{person.program === "Sickle" && (
															<Tooltip title="SATH">
																<img src="/images/programs_logo/sickle.svg" />
															</Tooltip>
														)}

														{person.program === "Nikshay" && (
															<Tooltip title="Nikshay">
																<img src="/images/programs_logo/nikshay.svg" />
															</Tooltip>
														)}

														{person.program === "Uwin" && (
															<Tooltip title="Uwin">
																<img src="/images/programs_logo/uwin.svg" />
															</Tooltip>
														)}

													</td>

													<td>
														<img src={photo} className="primage" alt="profile" />
													</td>

													<td className="fw-semibold">{name}</td>
													<td>{age}</td>
													<td>{gender}</td>
													<td>{phone}</td>

													<td>
														<button
															type="button"
															className="btn-success-abha"
															onClick={() => setData(person, person.program)}
														>
															<i className="fa fa-paper-plane"></i>
														</button>
													</td>

												</tr>
											);
										})}
									</table>
									{totalPages > 1 && (
										<nav className="d-flex pagination-wabha">
											<ul className="pagination">

												{/* Previous Button */}
												<li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
													<button
														className="page-link"
														onClick={() => setCurrentPage(currentPage - 1)}
													>
														Previous
													</button>
												</li>

												{/* Page Numbers */}
												{[...Array(totalPages)].map((_, index) => (
													<li
														key={index}
														className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
													>
														<button
															className="page-link"
															onClick={() => handlePageChange(index + 1)}
														>
															{index + 1}
														</button>
													</li>
												))}

												{/* Next Button */}
												<li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
													<button
														className="page-link"
														onClick={() => setCurrentPage(currentPage + 1)}
													>
														Next
													</button>
												</li>

											</ul>
										</nav>
									)}
									<button type="button" className="newprbtn" onClick={() => createNewProfile()}>
										{t('withoutabha.createNewProfile')}
									</button>
								</div>
							</div>
							{/* ====================For Mobile This ===================================*/}
							{totalPages > 1 && (
								<nav className="d-flex pagination-mobile mt-3">
									<ul className="pagination">

										{/* Previous Button */}
										<li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
											<button
												className="page-link"
												onClick={() => setCurrentPage(currentPage - 1)}
											>
												Previous
											</button>
										</li>

										{/* Page Numbers */}
										{[...Array(totalPages)].map((_, index) => (
											<li
												key={index}
												className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
											>
												<button
													className="page-link"
													onClick={() => handlePageChange(index + 1)}
												>
													{index + 1}
												</button>
											</li>
										))}

										{/* Next Button */}
										<li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
											<button
												className="page-link"
												onClick={() => setCurrentPage(currentPage + 1)}
											>
												Next
											</button>
										</li>

									</ul>
								</nav>
							)}
							<button type="button" className="newprbtn newprbtn-btn" onClick={() => createNewProfile()}>
								{t('withoutabha.createNewProfile')}
							</button>
						</>
					)}
				</div>
			</div>
		</div>
	);
};